import React from 'react';
import PropTypes from 'prop-types';
import { usePopulate } from 'api/APIHooks';
import authorizationShape from '../authorizationShape';
import AuthorizationHistoryLineItem from './AuthorizationHistoryLineItem';

const EditReasonLineItem = ({ authorization }) => {
  usePopulate(
    'service_authorization_edit_reason',
    'service_authorization_edit_reason',
    authorization,
    {
      queryConfig: {
        placeholderData: undefined,
      },
    },
  );

  const editReason = authorization.service_authorization_edit_reason?.reason || 'N/A';

  return (
    <AuthorizationHistoryLineItem field="Reason for Editing Authorization">
      {editReason}
    </AuthorizationHistoryLineItem>
  );
};

EditReasonLineItem.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
};

export default EditReasonLineItem;
